import React from 'react';

export default function Footer(props) {
    return (
        <div className="footer">
            { props.children }
        </div>
    )
}